import {useSetRecoilState} from 'recoil';
import {news} from '../state/news';
import {useQuery} from 'react-query';
import actions from '../api/news';

const useFetchNews = () => {
  const setNews = useSetRecoilState(news);
  return useQuery('fetchNews', async () => {
    const news = await actions.fetchNews();
    setNews(news?.data);
    return news;
  });
};

export default useFetchNews;
